import { render, staticRenderFns } from "./TableBrimolaClearing.vue?vue&type=template&id=4d63fc32"
import script from "./TableBrimolaClearing.vue?vue&type=script&lang=js"
export * from "./TableBrimolaClearing.vue?vue&type=script&lang=js"
import style0 from "./TableBrimolaClearing.vue?vue&type=style&index=0&id=4d63fc32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports